var _rect, _path, _path2, _path3, _circle, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSymbol = function SvgIconSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 43.75,
    rx: 2,
    fill: "#DAC6AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 30.938h21.875M6.25 24.063h21.875M6.25 17.188h21.875M6.25 10.313h21.875M6.25 37.813h18.125",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.617 25.443s7.698-3.687 11.974-4.193C33.866 20.744 42.5 22.5 42.5 22.5v23.75a5 5 0 0 1-5 5H15s-3.028-8.555-2.522-13.55c.507-4.995 5.139-12.257 5.139-12.257Z",
    fill: "#DAC6AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 40.313h14.375M16.25 30.313h18.125",
    stroke: "#fff",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.701,
    cy: 40.827,
    r: 20,
    transform: "rotate(-45 32.701 40.827)",
    fill: "#fff",
    fillOpacity: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.792 24.917c-8.787 8.787-8.787 23.033 0 31.82 8.189 8.189 21.12 8.746 29.954 1.67L54.8 66.46l3.535-3.535-8.052-8.052c7.076-8.834 6.519-21.766-1.67-29.955-8.787-8.787-23.034-8.787-31.82 0Zm3.535 3.535c6.834-6.834 17.915-6.834 24.749 0s6.834 17.915 0 24.749-17.915 6.834-24.749 0-6.834-17.915 0-24.749Z",
    fill: "#D1B896"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 67.343,
    width: 12.5,
    height: 22.5,
    rx: 4,
    transform: "rotate(-45 50.38 67.343)",
    fill: "#7D6E5A"
  })));
};
export default SvgIconSymbol;